
import React, { useEffect } from 'react';
import Navbar from '../component/Navbar';
import Hero from '../component/Hero';
import Fotter from '../component/Fotter';
import photo4 from '../assets/serviceimg.jpg';
import web from '../assets/web.jpg';
import graphics from '../assets/graphics.jpg';
import editor from '../assets/editor.jpg';
import promote from '../assets/promote.jpg';
const Service = () => {
  useEffect(() => {
    document.title = 'AN-TECH - SERVICES'; // Change the title as desired
    // Make sure to replace 'Your Website Name' with your actual website name
  }, []);

  return (
    <>
      <Navbar />

      <Hero
        backgroundImage={photo4}
        headingText="SERVICE BY AN-TECH"
        paraText="Turning ideas into solutions, one service at a time."
      />

      <section className="text-gray-400 bg-gray-900 body-font overflow-hidden">
        <div className="container px-5 py-24 mx-auto">
          <div className="-my-8 divide-y-2 divide-gray-800">
            <div className="py-8 flex flex-wrap md:flex-nowrap">
              <div className="md:w-1/2 lg:w-1/3 md:mb-0 mb-6">
                <img
                  src={web}
                  alt="Blog Image"
                  className="w-full h-auto object-cover object-center rounded border-2 border-white"
                />
              </div>

              <div className="md:w-1/2 lg:w-2/3 md:pl-10 md:py-6 mt-6 lg:mt-0">
                <span className="font-semibold title-font text-white">
                 WEB DEVLOPMENT
                </span>
                <h2 className="text-2xl font-medium text-white title-font mb-2">
                1. Web Development Services:
                </h2>
                <p className="leading-relaxed">
                At AN-TECH, we craft exceptional websites that captivate your audience and elevate your online presence. Our expert team of web developers specializes in creating custom, responsive, and user-friendly websites tailored to your unique needs. Whether you're a startup, small business, or a large enterprise, we have the expertise to bring your digital vision to life.
                </p>

              </div>
            </div>

            <div className="py-8 flex flex-wrap md:flex-nowrap">
              <div className="md:w-1/2 lg:w-1/3 md:mb-0 mb-6">
                <img
                  src={graphics}
                  alt="Blog Image"
                  className="w-full h-auto object-cover object-center rounded border-2 border-white"
                />
              </div>

              <div className="md:w-1/2 lg:w-2/3 md:pl-10 md:py-6 mt-6 lg:mt-0">
                <span className="font-semibold title-font text-white">
               GRAPHICS DESIGNING
                </span>
                <h2 className="text-2xl font-medium text-white title-font mb-2">
                2. Graphics Designing Services:
                </h2>
                <p className="leading-relaxed">
                Unlock the power of visual storytelling with AN-TECH's cutting-edge graphic design services. Our talented designers are skilled in transforming ideas into stunning visuals. From eye-catching logos to compelling marketing materials, we blend creativity with innovation to ensure your brand stands out in a crowded marketplace. Let us breathe life into your brand's identity.
                </p>

            
              </div>
            </div>

            <div className="py-8 flex flex-wrap md:flex-nowrap">
              <div className="md:w-1/2 lg:w-1/3 md:mb-0 mb-6">
                <img
                  src={editor}
                  alt="Blog Image"
                  className="w-full h-auto object-cover object-center rounded border-2 border-white"
                />
              </div>

              <div className="md:w-1/2 lg:w-2/3 md:pl-10 md:py-6 mt-6 lg:mt-0">
                <span className="font-semibold title-font text-white">
                SHORT VIDEO EDITING
                </span>
                <h2 className="text-2xl font-medium text-white title-font mb-2">
                 3.Short Video Production:
                </h2>
                <p className="leading-relaxed">
                In a world driven by video content, AN-TECH is your partner in creating engaging and memorable short videos. Our team excels in video production, offering end-to-end services, from concept development to final editing. Whether it's promotional videos, product demos, or social media content, we make videos that leave a lasting impression.
                </p>

             
              </div>
            </div>

    <div className="py-8 flex flex-wrap md:flex-nowrap">
              <div className="md:w-1/2 lg:w-1/3 md:mb-0 mb-6">
                <img
                  src={promote}
                  alt="Blog Image"
                  className="w-full h-auto object-cover object-center rounded border-2 border-white"
                />
              </div>

              <div className="md:w-1/2 lg:w-2/3 md:pl-10 md:py-6 mt-6 lg:mt-0">
                <span className="font-semibold title-font text-white">
                 COURSES AND PRODUCT PROMOTION
                </span>
                <h2 className="text-2xl font-medium text-white title-font mb-2">
                4. Courses and Product Promotion:
                </h2>
                <p className="leading-relaxed">
                AN-TECH doesn't just create content; we create results. Our expertise in courses and product promotion is unmatched. We know how to connect your offerings with the right audience. We'll design tailored promotional campaigns that maximize your reach and impact, ensuring your courses and products get the attention they deserve.

For each service, AN-TECH delivers not just a service but an experience that combines innovation, creativity, and strategy. Let us be your partner in success.
                </p>

              </div>
            </div>
 


          </div>
        </div>
      </section>

      <Fotter />
    </>
  );
};

export default Service;


